import fr from 'facet-rest';
import LabeledSwitch from 'Components/UI/LabeledSwitch';
import BaseOverride from '../../../Templates/BaseOverride';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('enabled', {
    _component: () => LabeledSwitch,
  });
